import { NavigationGuardNext, Route } from 'vue-router';
import applicationModule from '@/store/modules/application.module';
import router from '.';
import Vue from 'vue';

export function ensureAuthorized(to: Route, from: Route, next: NavigationGuardNext<Vue>) { 
    if(applicationModule.isAuthorized) {
        return next();
    }
    else {
        return next({ name: 'login' });
    }
}

export function ensureNotAuthorized(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
    if(!applicationModule.isAuthorized) {
        return next();
    }
    else {
        return next({ name: 'home' });
    }
}